import { render, staticRenderFns } from "./level_education.vue?vue&type=template&id=23f2dc7a&"
import script from "./level_education.vue?vue&type=script&lang=js&"
export * from "./level_education.vue?vue&type=script&lang=js&"
import style0 from "./level_education.vue?vue&type=style&index=0&id=23f2dc7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports